import MadathaKhaja from "../assets/sweets/MadathaKhaja.png";
import Badusha from "../assets/sweets/Badusha.png";
import BellamGavvalu from "../assets/sweets/BellamGavvalu.png";

// Snacks
import Mixture from "../assets/snacks/Mixture.png";
import KaraBoondi from "../assets/snacks/KaraBoondi.png";
import AgraMixture from "../assets/snacks/AgraMixture.png";

export const recommendedsweetsData = [
  {
    name: "Madatha Khaja",
    nameTe: "మడత ఖాజా",
    desc: "Khaja is basically Layered fritters made of maida flour and dunked in sugar syrup. The layering gives the sweet its desired flakiness. No festival is complete without this mouth-watering sweet in Andhra.",
    descTe: "ఖాజా అంటే మైదా పిండితో తయారు చేసిన పొరలు పొరలుగా ఉండే వేపుడు తీపి పదార్థం, పంచదార పాకంలో ముంచబడుతుంది. ఈ పొరలు తీపికి కావలసిన పొరలుదనాన్ని ఇస్తాయి. ఆంధ్రాలో ఏ పండుగైనా ఈ నోరూరించే తీపి లేకుండా పూర్తికాదు.",
    price: 200,
    quantity: "1 kg",
    image: MadathaKhaja,
  },
  {
    name: "Badusha",
    nameTe: "బాదుషా",
    desc: "A melt-in-your-mouth Indian sweet, deep-fried to golden perfection, soaked in sugar syrup, and adorned with a sprinkle of pistachios for a delightful treat",
    descTe: "నోట్లో వేసుకోగానే కరిగిపోయే ఈ భారతీయ తీపిని బంగారు రంగు వచ్చేవరకు వేయించి, పంచదార పాకంలో నానబెట్టి, పైన పిస్తా పలుకులతో అలంకరిస్తారు",
    price: 240,
    quantity: "1 kg",
    image: Badusha,
  },
  {
    name: "Bellam Gavvalu",
    nameTe: "బెల్లం గవ్వలు",
    desc: "Crispy, shell-shaped treats made with jaggery, combining the sweet allure of caramelized sugar with the delightful crunch of these traditional South Indian confections",
    descTe: "బెల్లంతో తయారు చేసిన గవ్వ ఆకారంలో ఉండే కరకరలాడే తీపి పదార్థం, కాల్చిన పంచదార తీపిదనాన్ని ఈ సాంప్రదాయ దక్షిణ భారత తినుబండారాల కరకరలాడే రుచితో మిళితం చేస్తుంది",
    price: 200,
    quantity: "1 kg",
    image: BellamGavvalu,
  },
];

export const recommendedSnacksData = [
  {
    name: "Mixture",
    nameTe: "మిక్చర్",
    desc: "Mixture is a popular South Indian snack made from a blend of crunchy ingredients like fried lentils, peanuts, curry leaves, and spices. It's known for its savory and spicy flavor, perfect for enjoying with tea or as a quick snack.",
    descTe: "మిక్చర్ అనేది వేయించిన పప్పులు, వేరుశనగలు, కరివేపాకు మరియు మసాలాల మిశ్రమంతో తయారు చేసిన ఒక ప్రసిద్ధ దక్షిణ భారత స్నాక్. ఇది ఘాటైన మరియు కారంగా ఉండే రుచికి ప్రసిద్ధి, టీతో లేదా త్వరిత స్నాక్‌గా ఆస్వాదించడానికి సరైనది.",
    price: 240,
    quantity: "1 kg",
    image: Mixture,
  },
  {
    name: "Kara Boondi",
    nameTe: "కారా బూంది",
    desc: "Kara Boondi is a crispy South Indian snack made from chickpea flour (besan), spices, and fried to a golden brown. Its savory, crunchy texture and spicy seasoning make it a favorite accompaniment with tea or as a snack on its own.",
    descTe: "కారా బూంది అనేది శనగపిండి, మసాలాలతో తయారు చేసి బంగారు గోధుమ రంగు వచ్చేవరకు వేయించిన కరకరలాడే దక్షిణ భారత స్నాక్. దీని ఘాటైన, కరకరలాడే ఆకృతి మరియు కారపు రుచి దీన్ని టీతో లేదా ఒంటరిగా ఆస్వాదించే ఇష్టమైన తినుబండారంగా చేస్తాయి.",
    price: 240,
    quantity: "1 kg",
    image: KaraBoondi,
  },
  {
    name: "Agra Mixture",
    nameTe: "ఆగ్రా మిక్చర్",
    desc: "Agra Mixture is a savory Indian snack known for its blend of crispy ingredients like chickpea flour noodles, peanuts, and spices. It offers a delightful crunch and spicy flavor, perfect for snacking or serving during gatherings.",
    descTe: "ఆగ్రా మిక్చర్ అనేది శనగపిండి నూడుల్స్, వేరుశనగలు మరియు మసాలాల వంటి కరకరలాడే పదార్థాల మిశ్రమానికి ప్రసిద్ధి చెందిన ఘాటైన భారతీయ స్నాక్. ఇది స్నాకింగ్‌కు లేదా సమావేశాలలో వడ్డించడానికి సరైన కరకరలాడే మరియు కారపు రుచిని అందిస్తుంది.",
    price: 240,
    quantity: "1 kg",
    image: AgraMixture,
  }
]
